import { createSelector } from "@reduxjs/toolkit";
import { TrackGrid } from "components/TrackGrid/TrackGrid";
import { shallowEqual } from "react-redux";
import { onlyUnique } from "Utility";
import { useAppSelector } from "app/hooks";
import { RootState } from "app/store";

interface Props {
  tournamentIds: string[];
}

export const TracksPageContent = ({ tournamentIds }: Props) => {
  const trackIds = useAppSelector(
    (state) => selectTournamentTrackIds(state, tournamentIds),
    shallowEqual
  );

  return <TrackGrid trackIds={trackIds} />;
};

// todo - pass in selectTrackIds selector rather than rewriting logic
const selectTournamentTrackIds = createSelector(
  [
    (state: RootState) => state.tournament.tournaments,
    (_, tournamentIds: string[]) => tournamentIds,
  ],
  (tournaments, tournamentIds) => {
    console.log(`Reselect tournamentIds - ${tournamentIds}`);

    return tournamentIds
      .flatMap((id) => tournaments[id]?.tracks.map((t) => t.id) ?? [])
      .filter(onlyUnique);
  }
);
